export default __webpack_public_path__ + "static/media/esrb-mature.a64f7a9e.png";